<template>
  <dropzone id="dropZoneOrtic" ref="pch"
            :duplicateCheck="true"
            :options="options"
            @vdropzone-mounted="vMount"
            @vdropzone-success="vsuccess"
            @vdropzone-error="verror"
            @vdropzone-removed-file="vremoved">
  </dropzone>
</template>

<style scoped>
.dz-image img {
  max-width: 100% !important;
}
</style>

<script>
import axios from 'axios'
import Dropzone from 'nuxt-dropzone'
import 'nuxt-dropzone/dropzone.css'

export default {
  name: 'o-dropzone',
  components: {
    Dropzone
  },
  props: {
    type: {
      type: String
    },
    saveUrl: {
      type: String
    },
    deleteUrl: {
      type: String
    }
  },
  data () {
    return {
      options: {
        url: this.saveUrl,
        uploadProgress: true,
        progress: true,
        paramName: 'file',
        addRemoveLinks: true,
        maxFiles: 20,
        dictDefaultMessage: this.$i18n.t('core.drop_or_select_files'),
        acceptedFiles: '.png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx,.zip'
      }
    }
  },
  methods: {
    vremoved (file, xhr, error) {
      const name = file.name
      const param = { 'file': name, 'servername': file.servername }
      if (name !== null && this.$refs.pch.dropzone.disabled !== true) {
        axios.post(this.deleteUrl, param).then((response) => {
          this.$emit('attachments', { file: name, servername: file.servername, action: 'delete' })
        }).catch((error) => {
          this.$emit('attachments', { file: name, servername: file.servername, action: 'delete' })
        })
      }
    },
    vsuccess (file, response) {
      file.servername = response.name ? response.name : null
      this.$emit('attachments', {
        file: file.name,
        servername: file.servername,
        action: 'upload',
        status: response.status
      })
    },
    verror (file) {
      this.$emit('attachments', { 'file': file.name, action: 'upload' })
    },
    vMount () {
      this.$refs.pch.removeAllFiles()
      this.$emit('attachments', { action: 'delete_all' })
    }
  }
}
</script>
